'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledTypeSkeletonStyle, StyledTypeStyle } from './styles';
export const BaseTypeStyle = forwardRef(({ textTransform, strikethrough, color, fontWeight, styleName, isUppercase: isUppercaseProp, asTag, ...rest }, ref) => {
    const isUppercase = isUppercaseProp ?? textTransform === 'uppercase';
    return (_jsx(StyledTypeStyle, { ref: ref, as: asTag, "$isUppercase": isUppercase, "$styleName": styleName, "$color": color, "$textTransform": textTransform, "$fontWeight": fontWeight, "$strikethrough": strikethrough, ...rest }));
});
export const BaseTypeStyleSkeleton = ({ styleName = 'bodyDefault', width, ...rest }) => {
    return _jsx(StyledTypeSkeletonStyle, { "$styleName": styleName, "$width": width, ...rest });
};
//# sourceMappingURL=BaseTypeStyle.js.map